function updateImages(selectedColor) {
  const color = selectedColor.toLowerCase();

  const thumbs = document.querySelectorAll("ul img");
  thumbs.forEach((img) => {
    const src = img.getAttribute("src")?.toLowerCase() || "";
    const alt = img.getAttribute("alt")?.toLowerCase() || "";
    const wrapper = img.closest("li");

    if (!wrapper) return;

    if (src.includes(`${color}-`) || alt.includes(`${color}-`)) {
      wrapper.style.display = "list-item";
    } else {
      wrapper.style.display = "none";
    }
  });
}

function initVariantImageSwitch() {
  const radios = document.querySelectorAll('input[type="radio"][name="Couleur"]');
  if (!radios.length) return;

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        setTimeout(() => {
          updateImages(radio.value);
        }, 100); // attendre que le DOM se mette à jour
      }
    });

    if (radio.checked) {
      updateImages(radio.value);
    }
  });
}

// ✅ relance l’init à chaque changement de DOM (ex: couleur changée dynamiquement par Shopify)
const observer = new MutationObserver(() => {
  initVariantImageSwitch();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ✅ Premier appel au chargement
window.addEventListener("load", () => {
  initVariantImageSwitch();
});
